import React, { useCallback, useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Title,
} from "chart.js";
import { useSelector } from "react-redux";
import { get, updateToken } from "../../../../helpers/api_helper";
import { Form } from "react-bootstrap";
import { ArrowUpCircle, ArrowDownCircle } from "react-bootstrap-icons";

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Title);

const EarningsSubscriptionsChart = ({ timeFrame, onTimeFrameChange }) => {
  const token = useSelector((state) => state.login.token);
  const [earnSubs, setEarnSubs] = useState([]);
  const [totals, setTotals] = useState({ earnings: 0, subscriptions: 0 });

  const fetchEarnSubs = useCallback(async () => {
    try {
      const response = await get(`/graph/earn-subs?timeFrame=${timeFrame}`);
      if (response?.success) {
        setEarnSubs(response?.data || []);
      } else {
        console.log(response.message || "Failed to fetch data");
      }
    } catch (error) {
      console.log(error);
    }
  }, [timeFrame]);

  useEffect(() => {
    if (token) {
      updateToken(token);
      fetchEarnSubs();
    }
  }, [token, fetchEarnSubs]);

  useEffect(() => {
    const totalEarnings = earnSubs.reduce(
      (acc, curr) => acc + curr.earnings,
      0
    );
    const totalSubscriptions = earnSubs.reduce(
      (acc, curr) => acc + curr.subscriptions,
      0
    );
    setTotals({ earnings: totalEarnings, subscriptions: totalSubscriptions });
  }, [earnSubs]);

  const generateLabels = () => {
    const labels = [];
    const today = new Date();

    if (timeFrame === "7days") {
      for (let i = 6; i >= 0; i--) {
        const date = new Date();
        date.setDate(today.getDate() - i);
        labels.push(date.toLocaleString("en-US", { weekday: "short" }));
      }
    } else if (timeFrame === "30days") {
      for (let i = 29; i >= 0; i--) {
        const date = new Date();
        date.setDate(today.getDate() - i);
        labels.push(date.toLocaleDateString());
      }
    } else if (timeFrame === "3months") {
      for (let i = 89; i >= 0; i--) {
        const date = new Date();
        date.setDate(today.getDate() - i);
        labels.push(date.toLocaleDateString());
      }
    }

    return labels.reverse();
  };

  const chartData = {
    labels: generateLabels(),
    datasets: [
      {
        label: "Earnings",
        data: earnSubs?.map((entry) => entry.earnings),
        borderColor: "darkgreen",
        backgroundColor: "rgba(0, 128, 0, 0.2)",
        fill: true,
      },
      {
        label: "Subscriptions",
        data: earnSubs?.map((entry) => entry.subscriptions),
        borderColor: "red",
        backgroundColor: "rgba(255, 0, 0, 0.2)",
        fill: true,
      },
    ],
  };

  return (
    <div className="cardBox p-3 h-100">
      <Form.Group controlId="timeFrameSelect">
        <Form.Select className="small-select" value={timeFrame} onChange={onTimeFrameChange}>
          <option value="7days">Last 7 Days</option>
          <option value="30days">Last Month</option>
          <option value="3months">Last 3 Months</option>
        </Form.Select>
      </Form.Group>
      <div
        className="totals"
        style={{
          display: "flex",
          justifyContent: "space-between",
          margin: "20px 0",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <ArrowUpCircle style={{ marginRight: "8px" }} />
          <div>
            <p style={{ margin: 0 }}>Earnings</p>
            <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
              ${totals.earnings.toFixed(2)}
            </p>
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <ArrowDownCircle style={{ marginRight: "8px" }} />
          <div>
            <p style={{ margin: 0 }}>Subscriptions</p>
            <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
              {totals.subscriptions}
            </p>
          </div>
        </div>
      </div>
      <Line data={chartData} />
    </div>
  );
};

export default EarningsSubscriptionsChart;
